// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"bcbe8ee5","453":"1428ded5"}[chunkId] + ".chunk.js";
};